import { render, staticRenderFns } from "./BioContentLinkRenderer.vue?vue&type=template&id=a537efca&scoped=true&"
import script from "./BioContentLinkRenderer.vue?vue&type=script&lang=js&"
export * from "./BioContentLinkRenderer.vue?vue&type=script&lang=js&"
import style0 from "./BioContentLinkRenderer.vue?vue&type=style&index=0&id=a537efca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a537efca",
  null
  
)

export default component.exports